import { TriangleExclamationSolidV6 } from "../../../shared/v2/Icomoon";

const NoUserSelectedAlert = () => (
  <div className="tw-flex tw-rounded-8px tw-border-[1px] tw-self-stretch tw-px-16px tw-py-12px tw-bg-[#FAE6E6] tw-rounded tw-outline-critical-light tw-justify-start tw-items-center tw-gap-16px">
    <div data-size="L" className="tw-inline-flex tw-flex-col tw-justify-center tw-items-center">
      <div className="tw-relative tw-overflow-hidden">
        <TriangleExclamationSolidV6 className="tw-text-[#E5342E]" />
      </div>
    </div>
    <div className="tw-flex-1 tw-inline-flex tw-flex-col tw-justify-center tw-items-start tw-gap-4px">
      <div className="tw-self-stretch tw-justify-start tw-text-[#A81E19] tw-font-bold tw-leading-20px">
        No Users Selected
      </div>
      <div className="tw-self-stretch tw-justify-start tw-text-[#E5342E] tw-text-sm tw-font-normal tw-leading-20px">
        Select a user to receive incoming calls
      </div>
    </div>
  </div>
);

export default NoUserSelectedAlert;
